import { motion } from "framer-motion";
import { Building2, Wrench, ShieldCheck, Sparkles, Siren, Cog, ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/content";
import { Reveal, Overline } from "@/components/site/Reveal";

const ICONS = { Building2, Wrench, ShieldCheck, Sparkles, Siren, Cog };

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="bg-white py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="mb-16 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <Reveal>
              <Overline>What We Do</Overline>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-5 max-w-2xl font-display text-4xl font-bold leading-[1.02] tracking-tighter text-[#0B3A82] sm:text-5xl md:text-6xl">
                Complete elevator services, end to end.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm font-body text-base leading-relaxed text-[#475569]">
              From first installation to lifelong maintenance — one trusted team
              for every lift in your building.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 gap-px bg-[#0B3A82]/10 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.title} delay={(i % 3) * 0.08} className="h-full">
                <motion.div
                  data-testid={`service-card-${i}`}
                  className="group relative flex h-full min-h-[420px] flex-col justify-end overflow-hidden bg-[#0B3A82] p-8"
                >
                  <div className="absolute inset-0 overflow-hidden">
                    <img
                      src={s.image}
                      alt={s.title}
                      className="h-full w-full object-cover opacity-40 transition-all duration-700 group-hover:scale-110 group-hover:opacity-55"
                    />
                    <div
                      className="absolute inset-0"
                      style={{
                        background:
                          "linear-gradient(180deg, rgba(8,42,95,0.35) 0%, rgba(8,42,95,0.92) 100%)",
                      }}
                    />
                  </div>

                  <div className="relative z-10">
                    <div className="mb-6 flex h-14 w-14 items-center justify-center border border-white/20 text-[#D89A18] transition-colors group-hover:border-[#D89A18]">
                      <Icon size={26} />
                    </div>
                    <h3 className="font-display text-2xl font-bold tracking-tight text-white">
                      {s.title}
                    </h3>
                    <p className="mt-3 font-body text-sm leading-relaxed text-white/70">
                      {s.desc}
                    </p>
                    <div className="mt-6 h-px w-0 bg-[#D89A18] transition-all duration-500 group-hover:w-16" />
                  </div>

                  <ArrowUpRight
                    size={22}
                    className="absolute right-8 top-8 z-10 text-white/50 transition-all duration-500 group-hover:text-[#D89A18] group-hover:rotate-45"
                  />
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
